/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Ukm_CostInputs */

const en_mk_sol_ukm_cost = /** @type {(inputs: Mk_Sol_Ukm_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Four back-office seats on the Team plan: Rp 396,000 a month. Branch heads can join as members without adding paid seats if they only read channels.`)
};

const id_mk_sol_ukm_cost = /** @type {(inputs: Mk_Sol_Ukm_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empat kursi kantor paket Tim: Rp 396.000 per bulan. Kepala cabang bisa diundang sebagai anggota tanpa menambah kursi berbayar bila hanya membaca channel.`)
};

/**
* | output |
* | --- |
* | "Four back-office seats on the Team plan: Rp 396,000 a month. Branch heads can join as members without adding paid seats if they only read channels." |
*
* @param {Mk_Sol_Ukm_CostInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_ukm_cost = /** @type {((inputs?: Mk_Sol_Ukm_CostInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Ukm_CostInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_ukm_cost(inputs)
	return en_mk_sol_ukm_cost(inputs)
});